import React, { useState, useEffect,useCallback } from "react";
import Breadcrumbs from "components/Breadcrumbs";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { getExpenseApi, getExpensesApi } from "api/services/expense";
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {  useNavigate } from "react-router-dom";
import { Table , Pagination} from "antd";
import { useSearchParams, useLocation } from 'react-router-dom';
import { formatDateHandler2 } from "utils/common";
import Image from "components/Image";
import { filterHandler } from 'utils/common';

import {  useSelector } from 'react-redux';

import {format} from "date-fns"

import { SkeltonLoader } from "components/skeltonLoader";
import { useMediaQuery } from "react-responsive";
import { Button } from "components/Button";


const Estimates = ({userData}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [dateTwo, setdateTwo] = useState(false);
  const [setSelectedOption] = useState(null);
  const [selectedDateTwo, setSelectedDateTwo] = useState(null);

  
  const [loading, setLoading] = useState(false)
  const [expenses, setExpenses] = useState([])
  const [expensesLoading, setExpensesLoading] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [selectedExpense, setSelectedExpense] = useState("");
  const [expenseModal, setExpenseModal] = useState(false);
  const [expenseStatusModal, setExpenseStatusModal] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [view, setView] = useState(isMobile? "grid":"list");

  const {
    user, userLoading   
} = useSelector((state) => state.user);
  const navigate = useNavigate();

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  

  useEffect(()=>{
    // console.log(id, modal, "MMM")
    const id = queryParams.get("id"); // Get 'id' param
    const modal = queryParams.get("modal"); // Get 'name' param
    // const { search } = useLocation();
    // const queryParams = new URLSearchParams(location?.search);
    console.log(queryParams, id ,  modal, queryParams,"MMM")

    if(id && modal){
      getExpenseApi(id, {}).then(response=>{
        setSelectedExpense(response?.data)
        setExpenseStatusModal(true)
      })
      
    }

  },[])


  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})


// const getFilterParams = useCallback(()=>{
//   let filter_params = filterHandler(filters)

//     return filter_params
        
// })
useEffect(()=>{
  // setExpenseParams(pageSettings)
},[pageSettings])

const setExpenseParams = (pageData) => {
//   let filter_params = getFilterParams()
  let params = {
      size: pageData?.pageSize,
      page: pageData?.page,
      sort_by: pageData?.sortBy || "",
      sort_type: pageData?.sortType || "",
    //   ...filter_params
  }
  setSearchParams(params)
}
  const fetchExpensesList = () => {
    setLoading(true)
    setExpensesLoading(true)
    // let filter_params = getFilterParams()
    let filter_params = {}
    if(filter_params?.reference_date){
      filter_params.reference_date = format(new Date(filter_params.reference_date), "yyyy-MM-dd")
  }
  if(filter_params?.posting_date){
      filter_params.posting_date = format(new Date(filter_params.posting_date), "yyyy-MM-dd")
  }



    getExpensesApi({
      sort_by:pageSettings?.sortBy,
      sort_type: pageSettings?.sortType,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      company_user: userData?.id,
    //   ...filter_params

    }).then(res => {
      if(view=="grid" && pageSettings?.page!==1){
        setExpenses([...expenses,...res.data.results]);

      }else{
        setExpenses(res.data.results)

      }

     
      setLoading(false)
      setShowFilterDrawer(false)
      setExpensesLoading(false)

    }).catch(e=>{
      setExpenses([])
      setLoading(false)
      setExpensesLoading(false)
    })

  }
  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    setPageSettings(pageData)
  };

  const handleExpenseAction = (record)=>{
    setSelectedExpense(record)
    setExpenseModal(true)
  }
  const handleExpenseStatusAction = (record)=>{
    setSelectedExpense(record)
    setExpenseStatusModal(true)
  }


  useEffect(()=>{
    if(userData?.id){
      fetchExpensesList()
    }
  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters, userData])
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      // sorter: true,
      render: (text, record, index) => (
        <h2 onClick={()=>{
          if(user?.id == record?.company_user.id){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
        }}  className="table-avatar d-flex">
         {text}
        </h2>
      ),
      sorter: (a, b) => a.id - b.id, 
      defaultSortOrder: "ascend"

    },
    {
      title: "Name",
      dataIndex: "first_name",
      // sorter: true,
      render: (text, record, index) => (
        <h2 onClick={()=>{

          if(user?.id == record?.company_user.id){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
          
          }}  className="table-avatar d-flex">
          <a 
          
          className="avatar">
            {/* <img alt="" src={record.profile_image} /> */}
            <Image src={record?.company_user?.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </a>
          <div>
          <a 
          // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
          className="profile-split d-flex flex-column">
            {record.company_user?.first_name} {record?.company_user?.last_name} 
          </a>
          {record?.company_user?.emp_no && (
            <span className="small text-muted">{ record.company_user?.emp_no}</span>
          )}

        
          </div>
        </h2>
      ),

    },
    // {
    //   title: "Position",
    //   dataIndex: "position_name",
    //   // sorter: true,
    //   render: (text, record, index) => (       
    //       <span>{record?.company_user?.position_name}</span>        
     
    //   ),
    //   align:"center"

    // },
    // {
    //   title: "Claim No",
    //   dataIndex: "claim_no",
    //   render: (text,record) => <span>{text}</span>,
    //   sorter: true,
    // },
    {
      title: "Ref Date",
      dataIndex: "reference_date",
      render: (text,record) => <span>{formatDateHandler2(text)}</span>,
      sorter:true,
    },

    {
      title: "Posting Date",
      dataIndex: "posting_date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter:true,
      align:"center"
    },
    
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter:true,
      align:"center"
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => <span>{text}</span>,

      sorter: true,
      align:"center"
    },

 
    {
      title: "Status",
      dataIndex: "approval_status",
      sorter: true,
      align: "center",
      render: (text) => (
        <div className="dropdown action-label text-center">
         <span
          className={`badge badge-soft-${
            text === "pending"
              ? "warning"  // Yellow
              : text === "approved"
              ? "success"  // Green
              : text === "cancelled"
              ? "dark" // Grey
              : "danger"  
  }`}
>
  {text}
</span>

        </div>
      ),
    },
 
    {
      title: "Next Approver",
      dataIndex: "approved_by",
      sorter: true,
      render: (text, record) => (
        <h2 className="table-avatar d-flex">
          {
            record?.current_approver &&
            <>
                    <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="avatar">
          {/* <img alt="" src={record.profile_image} /> */}
          <Image src={record?.current_approver?.profile_image}  type="user" style={{ objectFit: "cover" }} />
        </a>
        <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="profile-split d-flex flex-column">
          {record.current_approver?.first_name} {record?.current_approver?.last_name}
          {record?.current_approver?.emp_no && (
            <span className="small text-muted">{ record.current_approver.emp_no}</span>
          )}
        </a>
            </>
          }

      </h2>
      ),
    },
    {
      title: "Approved on",
      dataIndex: "approved_on",
      render: (text) => <span>{formatDateHandler2(text)}</span>,

      sorter: true,
    },
    {
      title: "Action",
      className: "text-end",
      sorter: true,
      render: (text,record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={()=>{
                if(user?.id == record?.company_user.id){
                  handleExpenseAction(record)
                }else{
                  handleExpenseStatusAction(record)
                }
              }}
            >
              <i className="fa fa-pencil m-r-5" /> Update
            </Link>
            {/* <Link
              className="dropdown-item"
              to="#"
              onClick={()=>handleExpenseStatusAction(record)}
            >
              <i className="fa fa-pencil m-r-5" /> Change status
            </Link> */}
            
          </div>
         

        </div>
      ),
    },
  ];
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {expenses.map((record, index) => (
            <div className="col-xxl-3 col-xl-4 col-md-6">
            <div className="contact-grid">
                <div className="grid-head">
                    <div className="users-profile">
                        <a onClick={()=>{
          if(user?.id == record?.company_user.id){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
        }}  className="avatar">
                            {/* <img src={employee?.profile_image} alt="" /> */}
                            <Image  src={record.company_user?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                        </a>
                        <h5 className="name-user">
                            <a onClick={()=>{
          if(user?.id == record?.company_user.id){
            handleExpenseAction(record)
          }else{
            handleExpenseStatusAction(record)
          }
        }} >{record.company_user?.first_name} {record?.company_user?.last_name} </a>
                            <span>{record.company_user?.emp_no}</span>
                        </h5>
                    </div>
                 
                </div>
                <div className="grid-body">
                    <div className="address-info">
                        <span>
                            <i className="la la-calendar" />
                            Reference : {formatDateHandler2(record.reference_date)}
                            {/* sharon@gmail.com */}
                        </span>
                        <span>
                            <i className="la la-calendar" />
                            Created : {formatDateHandler2(record.created_at)}
                        </span>
                        <span>
                            <i className="la la-user" />
                            Next Approver: {record.current_approver?.first_name} {record?.current_approver?.last_name}
                        </span>
                    </div>
                    <div className="grid-badges">
                        <span className="badge badge-soft-warning">{record?.approval_status}</span>
                    </div>
                </div>
               
            </div>
        </div>
          
          ))}
        </>
      );
    }
  };

  const handleGridChange = (page, size) =>{
    console.log(page, size, ")))))))))))))")
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  return (
    <>
    
        <div className="content container-fluid">
     

          
          

        {view == "grid" ? (
            <div className="row">
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination

                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}

                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                          
                        );
                      }
                      return null;
                    }}

                  />
                </div>
              </div>
            </div>
          ) : (<div className="table-responsive">
                {/* <SearchBox /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  columns={columns}
                  dataSource={expenses}

                  className="table-striped"
                  rowKey={(record) => record.id}
                  loading={expensesLoading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}

                />
              </div>)}


        </div>
      
   



    </>
  );
};

export default Estimates;
